import { toast } from "react-toastify";

import moment from "moment";

import TriangleRed from "images/Sense-Icons/triangle_red.svg";
import TriangleGreen from "images/Sense-Icons/triangle_green.svg";

import NumberIcon from "images/EDG/123.svg";
import CategoryIcon from "images/EDG/abc.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import NumberIconWhite from "images/EDG/123White.svg";
import CategoryIconWhite from "images/EDG/abcWhite.svg";
import DateIconWhite from "images/EDG/DateIconWhite.svg";

import FullPin from "images/Next-Icons/FullPinWhite.svg";
import EmptyPin from "images/Next-Icons/EmptyPinWhite.svg";
import InteractIcon from "images/InteractIcon.svg";

import JoinIcon from "images/Sense-Icons/JoinIcon.svg";
import AppendIcon from "images/Sense-Icons/AppendIcon.svg";
import DerivedIcon from "images/Sense-Icons/DerivedIcon.svg";
import FilterIcon from "images/Sense-Icons/FilterIcon.svg";
import CustomIcon from "images/Sense-Icons/CustomIcon.svg";
import IfElseIcon from "images/Sense-Icons/IfElse.svg";
import CodeIcon from "images/Sense-Icons/CodeIcon.svg";
import Code from "images/Sense-Icons/Code.svg";
import Paste from "images/Sense-Icons/Paste.svg";
import Sliders from "images/Sense-Icons/Sliders.svg";
import Sparkles from "images/Sense-Icons/Sparkles.svg";
import BanIcon from "images/Sense-Icons/ban-light.svg";
import PivotIcon from "images/Sense-Icons/angle-90-light.svg";
import DomoIcon from "images/domo-logo.svg";
import DataBricksIcon from "images/EDG/DB/databricks.png";

import datasetIcon from "images/tileIcons/dataset.svg";

import FullOuterIcon from "images/Sense-Icons/full-outer.svg";
import InnerJoinIcon from "images/Sense-Icons/inner-join.svg";
import LeftJoinIcon from "images/Sense-Icons/left-join.svg";
import LookupIcon from "images/Sense-Icons/lookup.svg";
import RightJoinIcon from "images/Sense-Icons/right-join.svg";

import LeftJoinIconGray from "images/left-join.svg";

import ClipboardIcon from "images/SenseIcons/clipboard.svg";
import GearsIcon from "images/SenseIcons/gears.svg";
import QuestionMarkIcon from "images/SenseIcons/question-mark.svg";

import FolderPickerIcon from "images/folder-migrate-white.svg";

import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as viewReducer from "containers/View/reducer";
import * as transformReducer from "containers/Dataset/reducer";

import { sanitizeAliasForBQ, isBQDataset } from "utils/relation";

const UPDATE_FIELD = "senseTransform/UPDATE_FIELD";

const initialState = {
  joinData: {},
  appendData: {},
  filterData: {},
  customTransforms: {},
  modifyFields: {},
  pivotData: {},
  autoTransformLabels: {},
  replayTransform: {},
  ignoredActions: {},
  isIdColumns: false
};

function senseTransformReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getSenseTransform(state) {
  return state.senseTransform;
}

export function getDatasetLabelFromId(state, datasetId) {
  return homeReducer.getDataset(state, datasetId)?.label || "...";
}

export function getDatasetFromId(state, datasetId) {
  return homeReducer.getDataset(state, datasetId);
}

export function getDatasetFromSourceUrl(state, sourceUrl) {
  const datasets = homeReducer.getDatasetsArr(state);

  return datasets ? datasets.find((d) => d.source?.url === sourceUrl) : undefined;
}

export function getReplayUpdates(state, dataset, transformQuery, isAddedFromPlan = false) {
  let replayUpdates = [];

  // IGNORE AUTO EXCLUDED COLUMNS (FROM MODIFY COLUMN NAME/TYPE)
  const excludeColumns =
    transformQuery?.exclude_columns === undefined
      ? []
      : transformQuery?.exclude_columns.filter((eColumn) => {
          const fMutate =
            transformQuery?.mutate === undefined
              ? undefined
              : transformQuery.mutate.find(
                  (mutate) =>
                    eColumn !== undefined &&
                    (mutate?.column === eColumn ||
                      (mutate?.expr?.type === "CAST" && mutate?.expr?.expr?.column === eColumn))
                );

          return fMutate === undefined ? true : false;
        });

  // EXCLUDE COLUMNS JQL TO READABLE
  if (excludeColumns.length > 0) {
    replayUpdates.push({
      type: "Exclude",
      data: excludeColumns,
      key: "exclude_columns",
      icon: FilterIcon,
      label: "Filtering Columns",
      subItem: excludeColumns?.reduce((a, b, i) => a + b + (i < excludeColumns.length - 1 ? ", " : ""), ""),
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  // APPEND JQL TO READABLE
  if (transformQuery?.unions !== undefined) {
    replayUpdates.push({
      type: "Append",
      data: transformQuery?.unions,
      key: "unions",
      icon: AppendIcon,
      label: "Appending Dataset",
      subItem: getDatasetLabelFromId(state, transformQuery?.unions?.[0]?.source),
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  // DEDUPLICATE JQL TO READABLE
  if (transformQuery?.distinct !== undefined) {
    replayUpdates.push({
      type: "Distinct",
      data: transformQuery?.distinct,
      key: "distinct",
      icon: BanIcon,
      label: "Deduplicate Rows",
      subItem: transformQuery?.distinct?.columns
        ? transformQuery.distinct.columns.reduce(
            (a, b, i) => a + (i < transformQuery.distinct.columns.length - 1 ? ", " : "") + b,
            ""
          )
        : "",
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  // PIVOT JQL TO READABLE
  if (transformQuery?.pivot !== undefined) {
    const columns =
      transformQuery?.pivot?.id_columns !== undefined && transformQuery?.pivot?.id_columns.length > 0
        ? transformQuery.pivot.id_columns
        : transformQuery?.pivot?.value_columns !== undefined
          ? transformQuery.pivot.value_columns
          : [];
    const isId = transformQuery?.pivot?.id_columns && transformQuery?.pivot?.id_columns.length > 0 ? true : false;

    replayUpdates.push({
      type: "Pivot",
      data: transformQuery?.pivot,
      key: "pivot",
      icon: PivotIcon,
      label: "Pivot Dataset",
      subItem:
        (isId ? "ID Columns: " : "Row Columns: ") +
        columns.reduce((a, b, i) => a + b + (i < columns.length - 1 ? ", " : ""), ""),
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  // PIVOT JQL TO READABLE
  if (transformQuery?.unpivot !== undefined) {
    const columns =
      transformQuery?.unpivot?.id_columns !== undefined && transformQuery?.unpivot?.id_columns.length > 0
        ? transformQuery.unpivot.id_columns
        : transformQuery?.unpivot?.value_columns !== undefined
          ? transformQuery.unpivot.value_columns
          : [];
    const isId = transformQuery?.unpivot?.id_columns && transformQuery?.unpivot?.id_columns.length > 0 ? true : false;

    replayUpdates.push({
      type: "Unpivot",
      data: transformQuery?.unpivot,
      key: "unpivot",
      icon: PivotIcon,
      label: "Unpivot Dataset",
      subItem:
        (isId ? "ID Columns: " : "Row Columns: ") +
        columns.reduce((a, b, i) => a + b + (i < columns.length - 1 ? ", " : ""), ""),
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  // PIVOT JQL TO READABLE
  if (transformQuery?.unpivot_and_pivot !== undefined) {
    const columns =
      transformQuery?.unpivot_and_pivot?.id_columns !== undefined &&
      transformQuery?.unpivot_and_pivot?.id_columns.length > 0
        ? transformQuery.unpivot_and_pivot.id_columns
        : transformQuery?.unpivot_and_pivot?.value_columns !== undefined
          ? transformQuery.unpivot_and_pivot.value_columns
          : [];
    const isId =
      transformQuery?.unpivot_and_pivot?.id_columns && transformQuery?.unpivot_and_pivot?.id_columns.length > 0
        ? true
        : false;

    const sourceDataset = getDatasetFromSourceUrl(state, transformQuery?.unpivot_and_pivot?.input?.source?.url);

    replayUpdates.push({
      type: "Pivot and Unpivot",
      data: transformQuery?.unpivot_and_pivot,
      key: "unpivot_and_pivot",
      icon: PivotIcon,
      label: "Pivot and Unpivot Dataset",
      subItem:
        (isId ? "ID Columns: " : "Row Columns: ") +
        columns.reduce((a, b, i) => a + b + (i < columns.length - 1 ? ", " : ""), ""),
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id,
      sourceDatasetId: sourceDataset?.id,
      isAddedFromPlan: isAddedFromPlan
    });
  }

  // JOIN JQL TO READABLE
  if (transformQuery?.joins !== undefined) {
    const join = transformQuery?.joins?.[0];

    replayUpdates.push({
      type: "Join",
      joinType:
        join.type === "INNER"
          ? "Inner Join"
          : join.type === "LOOKUP"
            ? "Lookup"
            : join.type === "LEFT"
              ? "Left Join"
              : join.type === "Right"
                ? "Right Join"
                : "Left Join",
      data: transformQuery?.joins,
      key: "joins",
      icon:
        join.type === "INNER"
          ? InnerJoinIcon
          : join.type === "LOOKUP"
            ? LookupIcon
            : join.type === "LEFT"
              ? LeftJoinIcon
              : join.type === "RIGHT"
                ? RightJoinIcon
                : JoinIcon,
      label: "Joining Dataset",
      subItem:
        (transformQuery?.joins?.[0]?.type === "INNER"
          ? "Inner"
          : transformQuery?.joins?.[0]?.type === "LEFT"
            ? "Left"
            : transformQuery?.joins?.[0]?.type !== undefined
              ? transformQuery?.joins?.[0]?.type
              : "Left") +
        " join with " +
        getDatasetLabelFromId(state, transformQuery?.joins?.[0]?.source),
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  // FILTER JQL TO READABLE
  if (transformQuery?.filter !== undefined) {
    replayUpdates.push({
      type: "Row Filter",
      data: transformQuery?.filter,
      key: "filter",
      icon: FilterIcon,
      label: "Row Filter",
      subItem: "",
      date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
      details: undefined,
      datasetId: dataset?.id
    });
  }

  const baseSelect = generateBaseSelect(state, dataset);

  // SELECT JQL TO READABLE
  if (transformQuery?.select !== undefined) {
    let derivedVariables = [];
    let customVariables = [];

    transformQuery?.select.forEach((select) => {
      if (select?.expr !== undefined || select?.exprs !== undefined) {
        derivedVariables.push(select);
      }

      if (select?.cases !== undefined) {
        customVariables.push(select);
      }
    });

    // DERIVED
    if (derivedVariables.length > 0) {
      replayUpdates.push({
        type: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
        key: "select",

        data: transformQuery?.select,
        icon: DerivedIcon,
        label: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
        subItem: derivedVariables.reduce(
          (a, b, i) => a + b?.alias + (derivedVariables.length === i + 1 ? "" : ", "),
          ""
        ),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // CUSTOM
    if (customVariables.length > 0) {
      customVariables.forEach((cSelect) => {
        replayUpdates.push({
          type: "Created If/Then/Else Rule",
          key: "select",

          data: cSelect,
          icon: IfElseIcon,
          label: "Created If/Then/Else Rule",
          subItem: customVariables.reduce(
            (a, b, i) => a + b?.alias + (customVariables.length === i + 1 ? "" : ", "),
            ""
          ),
          date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
          details: undefined,
          datasetId: dataset?.id
        });
      });
    }
  }

  // MUTATE JQL TO READABLE
  if (transformQuery?.mutate !== undefined) {
    let derivedVariables = [];
    let customVariables = [];
    let modifyType = [];
    let modifyCol = [];

    transformQuery?.mutate.forEach((mutate) => {
      if ((mutate?.expr !== undefined && mutate?.expr?.type !== "CAST") || mutate?.exprs !== undefined) {
        derivedVariables.push(mutate);
      }

      if (mutate?.expr !== undefined && mutate?.expr?.type === "CAST") {
        modifyType.push(mutate);
      }

      if (mutate?.column) {
        modifyCol.push(mutate);
      }

      if (mutate?.cases !== undefined) {
        customVariables.push(mutate);
      }
    });

    // DERIVED
    if (derivedVariables.length > 0) {
      replayUpdates.push({
        type: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
        key: "mutate",

        data: transformQuery?.mutate,
        icon: DerivedIcon,
        label: "Created Derived Variable" + (derivedVariables.length > 1 ? "s" : ""),
        subItem: derivedVariables.reduce(
          (a, b, i) => a + b?.alias + (derivedVariables.length === i + 1 ? "" : ", "),
          ""
        ),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // MODIFY TYPE
    if (modifyType.length > 0) {
      replayUpdates.push({
        type: "Updated Column Type" + (modifyType.length > 1 ? "s" : ""),
        key: "mutate",

        data: transformQuery?.mutate,
        icon: Sliders,
        label: "Updated Column Type" + (modifyType.length > 1 ? "s" : ""),
        subItem: modifyType.reduce(
          (a, b, i) =>
            a +
            (b?.alias + ": " + (b?.expr?.new_type === "TEXT" ? "Text" : "Number")) +
            (modifyType.length === i + 1 ? "" : ", "),
          ""
        ),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // MODIFY NAME
    if (modifyCol.length > 0) {
      replayUpdates.push({
        type: "Updated Column Name" + (modifyCol.length > 1 ? "s" : ""),
        key: "mutate",

        data: transformQuery?.mutate,
        icon: Sliders,
        label: "Updated Column Name" + (modifyCol.length > 1 ? "s" : ""),
        subItem: modifyCol.reduce(
          (a, b, i) => a + (b?.column + ": " + b?.alias) + (modifyCol.length === i + 1 ? "" : ", "),
          ""
        ),
        date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
        details: undefined,
        datasetId: dataset?.id
      });
    }

    // CUSTOM
    if (customVariables.length > 0) {
      customVariables.forEach((cSelect) => {
        replayUpdates.push({
          type: "Created If/Then/Else Rule",
          key: "mutate",

          data: cSelect,
          icon: IfElseIcon,
          label: "Created If/Then/Else Rule",
          subItem: customVariables.reduce(
            (a, b, i) => a + b?.alias + (customVariables.length === i + 1 ? "" : ", "),
            ""
          ),
          date: moment.utc(dataset?.updated_date).local().format("MMMM Do YYYY, h:mm:ss a"),
          details: undefined,
          datasetId: dataset?.id
        });
      });
    }
  }

  return replayUpdates;
}

export function getJoinData(state) {
  return getSenseTransform(state)?.joinData;
}

export function getAppendData(state) {
  return getSenseTransform(state)?.appendData;
}

export function getFilterData(state) {
  return getSenseTransform(state)?.filterData;
}

export function getCustomTransforms(state) {
  return getSenseTransform(state)?.customTransforms;
}

export function getModifyFields(state) {
  return getSenseTransform(state)?.modifyFields;
}

export function getPivotData(state) {
  return getSenseTransform(state)?.pivotData;
}

export function getAutoTransformLabels(state) {
  return getSenseTransform(state)?.autoTransformLabels;
}

export function getReplayTransform(state) {
  return getSenseTransform(state)?.replayTransform;
}

export function getIgnoredActions(state) {
  return getSenseTransform(state)?.ignoredActions;
}

export function getIsBadPivot(state, datasetId) {
  return getSenseTransform(state)?.isBadPivot;
}

export function getIsIdColumns(state, datasetId) {
  return getSenseTransform(state)?.isIdColumns;
}

// QUERY BUILDER TRANSFORM
export function getTransformQuery(state, dataset) {
  const datasetId = dataset?.id;

  const joinState = getJoinData(state)?.[datasetId];
  const appendState = getAppendData(state)?.[datasetId];
  const filterState = getFilterData(state)?.[datasetId];
  const customState = getCustomTransforms(state)?.[datasetId];
  const modifyState = getModifyFields(state)?.[datasetId];
  const pivotState = getPivotData(state)?.[datasetId];
  const aTransformLabels = getAutoTransformLabels(state)?.[datasetId];
  const selectedDatasets = getReplayTransform(state)?.[datasetId];
  const ignoredUpdates = getIgnoredActions(state)?.[dataset?.id];
  const isBadPivot = getIsBadPivot(state);
  const isIdColumns = getIsIdColumns(state);

  const autoTransforms = dataset?.dataTransforms;
  const manualTransforms = dataset?.manualTransforms;

  const excludeColumns = filterState?.exclude_columns;

  let retQuery = {
    query: {}
  };
  let infoQuery = {};

  // EXCLUDE COLUMNS
  if (excludeColumns && excludeColumns.length > 0) {
    retQuery.query.exclude_columns = excludeColumns.map((c) => c);
  }

  // FILTER
  if (filterState !== undefined) {
    const rowFilters = filterState?.row_filters
      ? filterState?.row_filters.filter((c) => ConditionUtils.isValid(c))
      : [];

    if (rowFilters && rowFilters.length > 0) {
      retQuery.query.filter = getConditionFromConditions(rowFilters);
    }

    if (filterState?.unique_id_columns) {
      retQuery.query.distinct = {
        columns: [...filterState?.unique_id_columns]
      };
    }
  }

  // JOINS
  if (joinState !== undefined && joinState?.lookupKeys && joinState?.selectedDataset) {
    retQuery.query.joins = [
      {
        source: joinState?.selectedDataset?.value?.id,
        type:
          joinState?.joinType === "LOOKUP" || joinState?.joinType === "RIGHT"
            ? joinState?.joinType === "LEFT"
            : joinState?.joinType !== undefined
              ? joinState?.joinType
              : "LEFT",
        prefix: joinState?.prefix,
        conditions: Object.keys(joinState?.lookupKeys)
          .filter((lKey) => joinState?.lookupKeys?.[lKey]?.isDelete !== true)
          .map((lKey) => ({
            left_key: joinState?.lookupKeys?.[lKey]?.left?.label,
            right_key: joinState?.lookupKeys?.[lKey]?.right?.label
          }))
      }
    ];
  }

  // DERIVED FIELDS
  if (autoTransforms && autoTransforms.length > 0) {
    if (retQuery.query.mutate === undefined) {
      retQuery.query.mutate = generateBaseSelect(state, dataset);
    }

    autoTransforms.forEach((auto) => {
      const expr = generateExpr(auto, aTransformLabels);

      if (expr) {
        retQuery.query.mutate.push(expr);
      }
    });
  }

  // CREATE DERIVED FIELDS (MANUAL CALC FIELDS)
  if (manualTransforms && Object.keys(manualTransforms).length > 0) {
    if (retQuery.query.mutate === undefined) {
      retQuery.query.mutate = generateBaseSelect(state, dataset);
    }

    Object.keys(manualTransforms)
      .filter(
        (mKey) =>
          manualTransforms[mKey]?.deleted !== true &&
          manualTransforms[mKey]?.fieldOne !== undefined &&
          manualTransforms[mKey]?.operation !== undefined
      )
      .forEach((mKey) => {
        const manual = manualTransforms[mKey];

        const expressionType = manual?.expressionType;
        const noSecondField = expressionType === "unary" || expressionType === "extract_date_part";

        const alias =
          manual?.columnLabel ||
          manual?.fieldOne?.value +
            "_" +
            manual?.operation?.value +
            (noSecondField ? "" : "_" + manual?.fieldTwo?.label);

        let pSelect;

        if (expressionType === "unary") {
          pSelect = Expressions.aliasedExpression(
            Expressions.unaryFunction(manual?.operation?.value, Expressions.column(manual?.fieldOne?.value)),
            alias
          );
        } else if (expressionType === "extract_date_part") {
          pSelect = Expressions.aliasedExpression(
            Expressions.datePart(Expressions.column(manual?.fieldOne?.value), manual?.operation?.value),
            alias
          );
        } else {
          pSelect = Expressions.aliasedExpression(
            Expressions.binaryOperation(manual?.operation?.value, [
              Expressions.column(manual?.fieldOne?.value),
              Expressions.column(manual?.fieldTwo?.value)
            ]),
            alias
          );
        }

        retQuery.query.mutate.push(pSelect);
      });
  }

  if (customState !== undefined && Object.keys(customState).length > 0) {
    if (retQuery.query.mutate === undefined) {
      retQuery.query.mutate = generateBaseSelect(state, dataset);
    }

    Object.keys(customState).forEach((cKey, cInd) => {
      const customCol = customState[cKey];

      const cases = customCol?.segments
        ? Object.keys(customCol.segments).map((sKey, vInd) => ({
            value:
              customCol.segments[sKey]?.columnValue !== undefined
                ? customCol.segments[sKey]?.columnValue
                : "Custom Value" + vInd,
            condition: getConditionFromConditions(customCol.segments[sKey]?.conditions)
          }))
        : [];

      const elseValue = customCol?.elseValue || "Other (Custom Field)";

      const alias = customCol?.columnName !== undefined ? customCol?.columnName : "Custom Field" + cInd;

      const retSelect = Expressions.ifThenWithAlias(cases, elseValue, alias);

      retQuery.query.mutate.push(retSelect);
    });
  }

  // APPEND
  if (appendState && appendState?.selectedDataset) {
    const unmatchedFields = appendState?.fields
      ? Object.keys(appendState.fields).filter((fKey) => appendState.fields[fKey]?.isAutomatic !== true)
      : [];

    retQuery.query.unions =
      unmatchedFields.length === 0
        ? [{ source: appendState?.selectedDataset?.id }]
        : [
            {
              source: {
                query: {
                  select: generateBaseSelect(
                    state,
                    appendState?.selectedDataset,
                    [],
                    unmatchedFields.map((uField) => ({
                      column: uField,
                      alias: appendState.fields[uField]?.label
                    }))
                  )
                },
                source: appendState?.selectedDataset?.id
              }
            }
          ];
  }

  const idColumnsClean = pivotState?.idColumns ? pivotState?.idColumns.map((c) => c.value) : [];
  const rowColumnsClean = pivotState?.rowColumns ? pivotState?.rowColumns.map((c) => c.value) : [];

  if (pivotState !== undefined) {
    if (isBadPivot === "Unpivot" || isBadPivot === undefined) {
      retQuery.query.unpivot = {
        id_columns:
          pivotState?.idColumns === undefined && pivotState?.rowColumns !== undefined && isIdColumns !== true
            ? Object.keys(dataset.fields)
                .filter((fKey) => rowColumnsClean.indexOf(fKey) === -1)
                .map((fKey) => fKey)
            : pivotState?.idColumns === undefined
              ? []
              : pivotState?.idColumns.map((c) => c.value),
        value_columns:
          pivotState?.rowColumns === undefined && pivotState?.idColumns !== undefined && isIdColumns == true
            ? Object.keys(dataset.fields)
                .filter((fKey) => idColumnsClean.indexOf(fKey) === -1)
                .map((fKey) => fKey)
            : pivotState?.rowColumns === undefined
              ? undefined
              : pivotState?.rowColumns.map((c) => c.value),
        variable_alias: pivotState?.varColName !== undefined ? pivotState?.varColName : "group",
        value_alias: pivotState?.valColName !== undefined ? pivotState?.valColName : "value"
      };
    } else if (isBadPivot === "Pivot") {
      retQuery.query.pivot = {
        id_columns: pivotState?.idColumns === undefined ? [] : pivotState?.idColumns.map((c) => c.value),
        wide_column: pivotState?.wideColumn !== undefined ? pivotState?.wideColumn : "value",
        wide_values: dataset.fields?.[pivotState?.wideColumn]?.data
          ? dataset.fields?.[pivotState?.wideColumn]?.data.map((d) => d.value)
          : [],
        value_column: pivotState?.valueColumn,
        agg_func: pivotState?.aggFunc !== undefined ? pivotState?.aggFunc : "first"
      };
    } else if (isBadPivot === "Both") {
      retQuery.query.unpivot_and_pivot = {
        id_columns:
          pivotState?.idColumns === undefined && pivotState?.rowColumns !== undefined && isIdColumns !== true
            ? Object.keys(dataset.fields)
                .filter((fKey) => rowColumnsClean.indexOf(fKey) === -1)
                .map((fKey) => fKey)
            : pivotState?.idColumns === undefined
              ? []
              : pivotState?.idColumns.map((c) => c.value),
        value_columns:
          pivotState?.rowColumns === undefined && pivotState?.idColumns !== undefined && isIdColumns == true
            ? Object.keys(dataset.fields)
                .filter((fKey) => idColumnsClean.indexOf(fKey) === -1)
                .map((fKey) => fKey)
            : pivotState?.rowColumns === undefined
              ? undefined
              : pivotState?.rowColumns.map((c) => c.value),
        variable_alias: pivotState?.varColName !== undefined ? pivotState?.varColName : "group",
        wide_column: pivotState?.wideColumn !== undefined ? pivotState?.wideColumn : "value",
        wide_values: dataset.fields?.[pivotState?.wideColumn]?.data
          ? dataset.fields?.[pivotState?.wideColumn]?.data.map((d) => d.value).filter((v) => v != "{Other}")
          : []
      };
    }
  }

  // MODIFY
  if (modifyState !== undefined) {
    if (retQuery.query.mutate === undefined) {
      retQuery.query.mutate = generateBaseSelect(state, dataset);
    }
  }

  let allUpdates = [];

  selectedDatasets &&
    selectedDatasets.forEach((d) => {
      const sDataset = d?.value;
      const transformQuery = sDataset?.transformations?.query;
      const replayUpdates = getReplayUpdates(state, sDataset, transformQuery);

      allUpdates = [...allUpdates, ...replayUpdates].filter(
        (u) => ignoredUpdates === undefined || ignoredUpdates?.[u?.datasetId + "_" + u.type] !== true
      );
    });

  if (allUpdates.length > 0) {
    allUpdates
      .filter((rUpdate) => rUpdate?.data?.cases === undefined)
      .forEach((rUpdate) => {
        if (rUpdate?.key === "filter") {
          if (retQuery?.query?.filter?.condition?.conditions !== undefined) {
            retQuery.query.filter.condition.conditions.push(rUpdate?.data);
          } else if (retQuery?.query?.filter?.condition) {
            const tCondition = { ...retQuery?.query?.filter?.condition };
            retQuery.query.filter.condition = {
              type: "AND",
              conditions: [...tCondition, ...rUpdate.data]
            };
          } else {
            retQuery.query.filter = rUpdate.data;
          }
        } else if (rUpdate?.key === "mutate") {
          if (retQuery?.query?.[rUpdate.key] === undefined) {
            retQuery.query[rUpdate.key] = [];
          }

          if (Array.isArray(rUpdate?.data)) {
            if (rUpdate?.type === "Created Derived Variable") {
              retQuery.query[rUpdate.key] = retQuery.query[rUpdate.key].concat(
                rUpdate?.data.filter((sObj) => sObj?.alias !== undefined && sObj?.alias === rUpdate?.subItem)
              );
            } else {
              retQuery.query[rUpdate.key] = retQuery.query[rUpdate.key].concat(
                rUpdate?.data.filter((x) => retQuery.query[rUpdate.key].find((y) => x.alias == y.alias) === undefined)
              );
            }
          } else {
            retQuery.query[rUpdate.key].push(rUpdate?.data);
          }
        } else if (rUpdate?.key === "exclude_columns") {
          if (retQuery?.query?.[rUpdate.key] === undefined) {
            retQuery.query[rUpdate.key] = [];
          }

          if (Array.isArray(rUpdate?.data)) {
            retQuery.query[rUpdate.key] = retQuery.query[rUpdate.key].concat(
              rUpdate?.data.filter((eKey) => retQuery.query[rUpdate.key].indexOf(eKey) === -1)
            );
          } else {
            retQuery.query[rUpdate.key].push(rUpdate?.data);
          }
        } else {
          retQuery.query[rUpdate.key] = rUpdate?.data;
        }
      });
  }

  if (isBQDataset(dataset)) {
    if (retQuery.query.project) {
      retQuery.query.project = retQuery.query.project.map((m) => {
        if (typeof m == "string") {
          return m;
        }

        return {
          ...m,
          alias: sanitizeAliasForBQ(m.alias)
        };
      });
    }

    if (retQuery.query.mutate) {
      retQuery.query.mutate = retQuery.query.mutate.map((m) => {
        if (typeof m == "string") {
          return m;
        }

        return {
          ...m,
          alias: sanitizeAliasForBQ(m.alias)
        };
      });
    }

    if (retQuery.query.unpivot) {
      retQuery.query.unpivot = {
        ...retQuery.query.unpivot,
        variable_alias: sanitizeAliasForBQ(retQuery.query.unpivot.variable_alias),
        value_alias: sanitizeAliasForBQ(retQuery.query.unpivot.value_alias)
      };
    }

    if (retQuery.query.unpivot_and_pivot) {
      retQuery.query.unpivot_and_pivot = {
        ...retQuery.query.unpivot_and_pivot,
        variable_alias: sanitizeAliasForBQ(retQuery.query.unpivot_and_pivot.variable_alias)
      };
    }
  }

  return retQuery;
}

export function getConditionFromConditions(conditions) {
  return conditions === undefined
    ? {}
    : conditions.length === 1
      ? { ...conditions[0] }
      : { type: "AND", conditions: [...conditions] };
}

export function generateBaseSelect(state, dataset, excludeColumns = [], replaceColumns = []) {
  const modifyState = getModifyFields(state, dataset?.id);

  let retSelect = [];

  dataset &&
    dataset.fields &&
    Object.keys(dataset.fields)
      .filter((f) => excludeColumns.find((c) => c === f) === undefined)
      .forEach((fKey) => {
        const modify = modifyState?.[fKey];
        const replaceColumn = replaceColumns.find((r) => r?.column === fKey);

        let retSelectField = replaceColumn ? replaceColumn : fKey;

        if (modify) {
          if (modify?.changeType) {
            retSelectField = Expressions.aliasedExpression(
              Expressions.cast(Expressions.column(fKey), modify?.changeType),
              modify?.changeName || fKey
            );
          } else {
            retSelectField = Expressions.columnProjection(fKey, modify?.changeName);
          }

          retSelect.push(retSelectField);
        }
      });

  return retSelect;
}

export function generateExpr(autoTransform, autoTransformLabels) {
  const dateTypes = [
    { type: "MonthlySeasonalityTransform", part: "month" },
    { type: "WeekdaySeasonalityTransform", part: "dow" },
    { type: "TimeTrendTransform", part: "epoch" }
  ];

  const mathTypes = [
    { type: "LogTransform", func: "log" },
    { type: "SquareRootTransform", func: "sqrt" }
  ];

  const mType = mathTypes.find((f) => f.type === autoTransform?.type);
  const dType = dateTypes.find((f) => f.type === autoTransform?.type);

  const alias =
    autoTransformLabels?.[autoTransform?.variable + "_" + autoTransform?.type] ||
    autoTransform?.variable + "_" + autoTransform?.type;

  const retExpr =
    autoTransform?.type === "ReciprocalTransform"
      ? Expressions.binaryOperation("/", [1, Expressions.column(autoTransform?.variable)])
      : mType
        ? Expressions.unaryFunction(mType?.func, Expressions.column(autoTransform?.variable))
        : dType
          ? Expressions.datePart(Expressions.column(autoTransform?.variable), dType?.part)
          : undefined;

  if (retExpr === undefined) {
    return retExpr;
  }

  return Expressions.aliasedExpression(retExpr, alias);
}

/* Actions */
export function updateIsOpen(isOpen) {
  return { type: UPDATE_FIELD, data: isOpen, key: "isOpen" };
}

export function updateIsBadPivot(isBadPivot) {
  return { type: UPDATE_FIELD, key: "isBadPivot", data: isBadPivot };
}

export function updateIsIdColumns(isIdColumns) {
  return { type: UPDATE_FIELD, key: "isIdColumns", data: isIdColumns };
}

export function handleIgnoreAction(table, action) {
  return (dispatch, getState) => {
    const dataset = { id: "new_" + table.name };

    const ignoredActions = getIgnoredActions(getState(), dataset?.id);
    const customTransforms = getCustomTransforms(getState(), dataset?.id);

    const isIgnored = ignoredActions?.[dataset?.id]?.[action.datasetId + "_" + action.type];

    // Custom select
    if (action?.data?.cases) {
      if (isIgnored !== true) {
        const segKey = customTransforms?.[dataset?.id]
          ? Object.keys(customTransforms?.[dataset?.id]).find(
              (sKey) => customTransforms[dataset.id][sKey]?.columnName === action?.data?.alias
            )
          : undefined;

        if (segKey !== undefined) {
          dispatch(deleteCustomTransforms(dataset?.id, segKey));
        }
      } else {
        dispatch(handleAddAction(dataset, action?.data));
      }
    }

    if (action?.type === "Pivot" || action?.type === "Unpivot" || action?.type === "Pivot and Unpivot") {
      if (isIgnored !== true) {
        dispatch(deletePivotAction(dataset));
      } else {
        dispatch(
          handleAddPivotAction(dataset, action?.data, action?.type === "Pivot and Unpivot" ? "Both" : action.type)
        );
      }
    }

    return dispatch({
      type: UPDATE_FIELD,
      key: "ignoredActions",
      data: {
        ...ignoredActions,
        [dataset?.id]: {
          ...(ignoredActions?.[dataset?.id] || {}),
          [action.datasetId + "_" + action.type]: !isIgnored
        }
      }
    });
  };
}

export function handleAddAction(dataset, customSelect) {
  return (dispatch, getState) => {
    const replayTransform = getReplayTransform(getState());
    const customTransforms = getCustomTransforms(getState());

    let retCustomTransforms = JSON.parse(JSON.stringify(customTransforms));
    const retCustomState = { ...retCustomTransforms[dataset?.id] };

    const segments = customSelect.cases.map((c) => ({
      columnValue: c.value,
      conditions: [c.condition]
    }));

    retCustomTransforms[dataset.id] = {
      ...retCustomState,
      [Object.keys(retCustomState).length]: {
        columnName: customSelect.alias,
        segments: segments,
        elseValue: customSelect?.else_value ? customSelect?.else_value : undefined
      }
    };

    return dispatch({
      type: UPDATE_FIELD,
      key: "customTransforms",
      data: retCustomTransforms
    });
  };
}

export function deletePivotAction(dataset) {
  return (dispatch, getState) => {
    const replayTransform = getReplayTransform(getState());
    const pivotData = getPivotData(getState());

    let retPivotData = pivotData ? JSON.parse(JSON.stringify(pivotData)) : {};

    delete retPivotData[dataset.id];

    dispatch(updateIsBadPivot(undefined));
    return dispatch({
      type: UPDATE_FIELD,
      key: "pivotData",
      data: retPivotData
    });
  };
}

export function handleAddPivotAction(dataset, pivotAction, pivotType) {
  return (dispatch, getState) => {
    const replayTransform = getReplayTransform(getState());
    const pivotData = getPivotData(getState());

    let retPivotData = pivotData ? JSON.parse(JSON.stringify(pivotData)) : {};

    retPivotData[dataset.id] = {
      ...retPivotData[dataset.id],
      varColName: pivotAction?.variable_alias,
      valColName: pivotAction?.value_alias,
      idColumns: pivotAction?.id_columns ? pivotAction?.id_columns.map((c) => ({ value: c, label: c })) : undefined,
      rowColumns: pivotAction?.value_columns
        ? pivotAction?.value_columns.map((c) => ({ value: c, label: c }))
        : undefined,
      wideColumn: pivotAction?.wide_column ? pivotAction?.wide_column : undefined,
      valueColumn: pivotAction?.value_column ? pivotAction?.value_column : undefined,
      aggFunc: pivotAction?.agg_func ? pivotAction?.agg_func : undefined
    };

    dispatch({ type: UPDATE_FIELD, key: "pivotData", data: retPivotData });
    dispatch(updateIsBadPivot(pivotType));
    return dispatch(updateIsIdColumns(true));
  };
}

export function handleAddDedupe(datasetId, column) {
  return (dispatch, getState) => {
    const filterData = getFilterData(getState());

    return dispatch({
      UPDATE_FIELD,
      key: "filterData",
      data: {
        ...filterData,
        [datasetId]: {
          ...(filterData?.[datasetId] || {}),
          unique_id_columns: [column]
        }
      }
    });
  };
}

export function handleAddFilter(datasetId, filter) {
  return (dispatch, getState) => {
    const filterData = getFilterData(getState());

    return dispatch({
      UPDATE_FIELD,
      key: "filterData",
      data: {
        ...filterData,
        [datasetId]: {
          ...(filterData?.[datasetId] || {}),
          row_filters: [filter]
        }
      }
    });
  };
}

export function handleRemoveReplay(table, rDataset) {
  return (dispatch, getState) => {
    const replayTransform = getReplayTransform(getState());
    const customTransforms = getCustomTransforms(getState());
    const filterData = getFilterData(getState());
    const appendData = getAppendData(getState());
    const pivotData = getPivotData(getState());
    const joinData = getJoinData(getState());

    const oDataset = getDatasetFromTable(getState(), table);

    const query = rDataset?.transformations?.query;

    console.log("hanbdle remove replay oDatset rDataset", oDataset, rDataset);

    if (query?.unions) {
      dispatch({
        type: UPDATE_FIELD,
        key: "appendData",
        data: { ...appendData, [oDataset?.id]: undefined }
      });
    }

    if (query?.distinct?.columns?.[0]) {
      dispatch({
        type: UPDATE_FIELD,
        key: "filterData",
        data: { ...filterData, [oDataset?.id]: undefined }
      });
    }

    if (query?.filter) {
      dispatch({
        type: UPDATE_FIELD,
        key: "filterData",
        data: { ...filterData, [oDataset?.id]: undefined }
      });
    }

    if (query?.select) {
      if (query.select.filter((s) => s?.cases !== undefined).length > 0) {
        dispatch({
          type: UPDATE_FIELD,
          key: "customTransforms",
          data: {
            ...customTransforms,
            [oDataset?.id]: undefined
          }
        });
      }
    }
    if (query?.mutate) {
      query.mutate.forEach((customSelect) => {
        if (customSelect.type === "EXPRESSION") {
          //TODO handle removing manuald erived fields ehrer
        } else {
          dispatch({
            type: UPDATE_FIELD,
            key: "customTransforms",
            data: {
              ...customTransforms,
              [oDataset?.id]: undefined
            }
          });
        }
      });
    }
    if (query?.unpivot_and_pivot || query?.pivot || query?.unpivot) {
      let pivotData = pivotData;

      delete pivotData[oDataset?.id];

      dispatch({
        type: UPDATE_FIELD,
        key: "pivotData",
        data: { ...pivotData }
      });
    }

    if (query?.joins) {
      dispatch({
        type: UPDATE_FIELD,
        key: "joinData",
        data: {
          ...joinData,
          [oDataset?.id]: undefined
        }
      });
    }
  };
}

export function getDatasetFromTable(state, table) {
  const datasets = viewReducer.getDatasets(state);

  console.log("what is table?", table, datasets);

  return datasets?.[0];
}

export function handleReplay(table, datasetOptions) {
  return (dispatch, getState) => {
    const replayTransform = getReplayTransform(getState());
    const customTransforms = getCustomTransforms(getState());

    console.log("hr", table, datasetOptions);

    const oDataset = { id: "new_" + table.name };

    const oldDatasetOptions = replayTransform?.[oDataset?.id];

    const nDatasets =
      datasetOptions === undefined
        ? []
        : datasetOptions.filter(
            (d) =>
              oldDatasetOptions === undefined ||
              oldDatasetOptions.filter((o) => o?.value?.id === d?.value?.id).length === 0
          );

    console.log("what is dao", datasetOptions, oldDatasetOptions, nDatasets);

    nDatasets.forEach((tDataset) => {
      const query = tDataset?.value?.transformations?.query;

      if (query?.unions) {
        query.unions.forEach((union) => {
          const uDataset = getDatasetFromId(getState(), union.source);
          dispatch(handleUpdateAppendDataset(oDataset, uDataset));
        });
      }

      if (query?.distinct?.columns?.[0]) {
        dispatch(handleAddDedupe(oDataset?.id, query?.distinct?.columns?.[0]));
      }

      if (query?.filter) {
        dispatch(handleAddFilter(oDataset?.id, query?.filter));
      }

      if (query?.select) {
        query.select
          .filter((s) => s?.cases !== undefined)
          .forEach((customSelect) => {
            dispatch(handleAddAction(oDataset, customSelect));
          });
      }
      if (query?.mutate) {
        query.mutate.forEach((customSelect) => {
          if (customSelect.type === "EXPRESSION") {
            dispatch(
              transformReducer.addField(
                oDataset?.id,
                {
                  value: customSelect?.expr?.operator,
                  label: customSelect?.expr?.operator
                },
                {
                  one: customSelect?.expr?.exprs?.[0]?.column,
                  two: customSelect?.expr?.exprs?.[1]?.column
                },
                { columnLabel: customSelect.alias }
              )
            );
          } else {
            dispatch(handleAddAction(oDataset, customSelect));
          }
        });
      }
      if (query?.unpivot_and_pivot) {
        dispatch(handleAddPivotAction(oDataset, query.unpivot_and_pivot, "Both"));
      } else if (query?.pivot) {
        dispatch(handleAddPivotAction(oDataset, query.pivot, "Pivot"));
      } else if (query?.unpivot) {
        dispatch(handleAddPivotAction(oDataset, query.unpivot, "Unpivot"));
      }

      if (query?.joins) {
        query.joins.forEach((join) => {
          const jDataset = getDatasetFromId(getState(), join.source);

          const selectedDataset = {
            label: jDataset?.label,
            value: jDataset
          };

          let jData = {
            selectedDataset: selectedDataset,
            prefix: join.prefix,
            type: join.type,
            lookupKeys: {}
          };

          if (join.conditions !== undefined) {
            join.conditions.forEach((lookKey, lookIndex) => {
              jData.lookupKeys[lookIndex] = {
                left: lookKey["left_key"],
                right: lookKey["right_key"]
              };
            });
          }

          dispatch(updateJoinBase(oDataset?.id, jData));
        });
      }
    });

    dispatch({
      type: UPDATE_FIELD,
      key: "replayTransform",
      data: { ...replayTransform, ["new_" + table.name]: datasetOptions }
    });
  };
}

export function clearReplay() {
  return (dispatch, getState) => {
    return dispatch({
      type: UPDATE_FIELD,
      key: "replayTransform",
      data: undefined
    });
  };
}

// BEGIN BAD CUSTOM TRANSFORM
// TODO: Move this into nice neat reducer and container.
// Only relies on dataset object
export function updateCustomTransforms(datasetId, key, data) {
  return (dispatch, getState) => {
    const customTransforms = getCustomTransforms(getState());

    return dispatch({
      type: UPDATE_FIELD,
      key: "customTransforms",
      data: {
        ...customTransforms,
        [datasetId]: {
          ...customTransforms?.[datasetId],
          [key]: data
        }
      }
    });
  };
}

export function deleteCustomTransforms(datasetId, key) {
  return (dispatch, getState) => {
    const customTransforms = getCustomTransforms(getState());

    let retCustomTransforms = { ...customTransforms };

    if (retCustomTransforms?.[datasetId]?.[key]) {
      delete retCustomTransforms[datasetId][key];

      return dispatch({
        type: UPDATE_FIELD,
        key: "customTransforms",
        data: retCustomTransforms
      });
    }
  };
}

export function deleteCustomTransformSegment(datasetId, key, segmentIndex) {
  return (dispatch, getState) => {
    const customTransforms = getCustomTransforms(getState());

    let retCustomTransforms = { ...customTransforms };

    if (retCustomTransforms?.[datasetId]?.[key]?.segments) {
      delete retCustomTransforms[datasetId][key].segments[segmentIndex];

      return dispatch({
        type: UPDATE_FIELD,
        key: "customTransforms",
        data: retCustomTransforms
      });
    }
  };
}

export function getInitTransform() {
  return {
    segments: [{ columnName: undefined, columnValue: undefined, conditions: [] }]
  };
}

export function updateCustomTransform(datasetId, index, key, data) {
  return (dispatch, getState) => {
    const customTransforms = getCustomTransforms(getState());

    return dispatch({
      type: UPDATE_FIELD,
      key: "customTransforms",
      data: {
        ...customTransforms,
        [datasetId]: {
          ...customTransforms?.[datasetId],
          [index]: {
            ...(customTransforms?.[datasetId]?.[index] || getInitTransform()),
            [key]: data
          }
        }
      }
    });
  };
}

export function updateCustomTransformSegment(datasetId, colIndex, segIndex, key, data) {
  return (dispatch, getState) => {
    const customTransforms = getCustomTransforms(getState());

    const cTransforms = customTransforms?.[datasetId] || {};

    let retSegments = cTransforms?.[colIndex]?.segments
      ? { ...cTransforms[colIndex].segments }
      : { ...getInitTransform().segments };

    retSegments[segIndex] = {
      ...retSegments[segIndex],
      [key]: data
    };

    dispatch(updateCustomTransform(datasetId, colIndex, "segments", retSegments));
  };
}

export function addSegment(datasetId, colIndex) {
  return (dispatch, getState) => {
    const customTransforms = getCustomTransforms(getState());

    const cTransforms = customTransforms?.[datasetId] || {};

    let retSegments = cTransforms?.[colIndex]?.segments ? { ...cTransforms[colIndex].segments } : {};

    retSegments[Object.keys(retSegments).length] = {
      columnName: undefined,
      columnValue: undefined,
      conditions: [],
      elseValue: "Other (Custom Field)"
    };

    dispatch(updateCustomTransform(datasetId, colIndex, "segments", retSegments));
  };
}

export function updateJoinData(datasetId, key, data) {
  return (dispatch, getState) => {
    const joinData = getJoinData(getState());

    return dispatch({
      type: UPDATE_FIELD,
      key: "joinData",
      data: {
        ...joinData,
        [datasetId]: {
          ...joinData?.[datasetId],
          [key]: data
        }
      }
    });
  };
}

export function updateJoinBase(datasetId, data) {
  return (dispatch, getState) => {
    const joinData = getJoinData(getState());

    return dispatch({
      type: UPDATE_FIELD,
      key: "joinData",
      data: {
        ...joinData,
        [datasetId]: {
          ...data
        }
      }
    });
  };
}

export function updateLookupKey(datasetId, index, data) {
  return (dispatch, getState) => {
    const joinData = getJoinData(getState());

    return dispatch({
      type: UPDATE_FIELD,
      key: "joinData",
      data: {
        ...joinData,
        [datasetId]: {
          ...joinData?.[datasetId],
          ["lookupKeys"]: {
            ...joinData?.[datasetId]?.lookupKeys,
            [index]: { ...joinData?.[datasetId]?.lookupKeys?.[index], ...data }
          }
        }
      }
    });
  };
}

export function deleteLookupKey(datasetId, index) {
  return (dispatch, getState) => {
    return dispatch(updateLookupKey(datasetId, index, { isDelete: true }));
  };
}

// Lol Append reducer. TODO: Real Append. reduccer
export function updateAppendData(datasetId, key, data) {
  return (dispatch, getState) => {
    const appendData = getAppendData(getState());

    return dispatch({
      type: UPDATE_FIELD,
      key: "appendData",
      data: {
        ...appendData,
        [datasetId]: key
          ? {
              ...appendData?.[datasetId],
              [key]: data
            }
          : { ...data }
      }
    });
  };
}

export function handleUpdateAppendDataset(dataset, appendDataset) {
  return (dispatch, getState) => {
    let retAppend = {
      selectedDataset: appendDataset,
      fields: {}
    };

    appendDataset?.fields &&
      Object.keys(appendDataset.fields).forEach((oKey) => {
        const field = appendDataset.fields[oKey];

        const foundField = dataset?.fields
          ? Object.keys(dataset.fields).find((fKey) => fKey === field.label)
          : undefined;

        retAppend.fields[oKey] =
          foundField !== undefined
            ? {
                label: foundField,
                value: dataset.fields[foundField],
                isAutomatic: true
              }
            : undefined;
      });

    dispatch(updateAppendData(dataset?.id, undefined, retAppend));
  };
}

export default senseTransformReducer;
